declare namespace $ {

	export class $lim_rtest2_logo extends $mol_icon_molecule {
	}
	
}

//# sourceMappingURL=logo.view.tree.d.ts.map